import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import styles from "./styles.css"
const Description = ({ className, children }) => {
  return (
    <div className={classnames(styles.containerDetailsClass, className)}>
      {children}
    </div>
  )
}
Description.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}
export default Description



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/Description/index.js